import {
  loadRecommendations,
  loadRecommendationForBlock,
  updateRecommendation,
} from './slices';
import { loadAnomaliesForBlocks } from '../anomaly/actions';

const loadRecommendationsWithAnomaly = (blockIds) => (dispatch) => {
  dispatch(loadRecommendations());
  if (blockIds && blockIds.length) dispatch(loadAnomaliesForBlocks(blockIds));
};

export {
  loadRecommendations,
  loadRecommendationForBlock,
  updateRecommendation,
  loadRecommendationsWithAnomaly,
};
